export default {
  all: 'Todos',
  app_disabled: 'El contenido está siendo actualizado, en breve estará disponible.',
  autocomplete_placeholder: 'Ingresa tu dirección o Código postal',
  back_to_list: 'Volver al listado',
  catalogue_image: 'Imagen del catálogo',
  catalogue_loading: 'Estamos buscando tu catálogo',
  catalogues: 'Catálogos',
  catalogues_in_area: 'Catálogos en tu zona',
  catalogues_loading: 'Cargando',
  catalogues_near_you: 'Catálogos cercanos',
  catalogues_not_found:
    'Por el momento no hay folletos aplicables a tu zona, intenta elegir una dirección diferente o vuelve pronto para encontrar ofertas.',
  close_catalogues: 'Cerrar',
  close_products: 'Cerrar',
  close_stores: 'Cerrar',
  closed: 'Cerrado',
  characteristics: 'Características',
  days_of_week: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  description_missing: 'No hay descripción disponible',
  expires: 'Caduca',
  expired: 'Caducado',
  find_me: 'Encuéntrame',
  geolocation_error: 'Atención. La ubicación no ha generado resultados.',
  geolocation_image: 'Geolocalización',
  geolocation_info:
    'Para enseñarte los catálogos en tu alrededor, necesitamos conocer tu ubicación. Ingresa tu dirección o CP',
  geolocation_loading: 'Estamos configurando tu ubicación',
  geolocation_missing: 'Actualiza tu ubicación para ver las ofertas y las tiendas más cercanas',
  localize_yourself: 'Ubicarme',
  more_info: 'Descubre más',
  next: 'Siguiente',
  not_now: 'Ahora no',
  of: 'De',
  open: 'Abierto',
  open_24_hours: 'Abierto las 24 horas',
  or: 'ó',
  other_stores: 'Ofertas disponibles aquí también',
  page: 'Página',
  previous: 'Anterior',
  price: 'Precio',
  products: 'Productos',
  products_find: 'Busca un producto',
  index: 'Índice',
  products_list: 'Lista de productos',
  read_all: 'Leer todo',
  sale: 'Descuento',
  search_placeholder: '¿Qué quieres encontrar?',
  stores: 'Tiendas',
  understand: 'Entiendo',
  usergeolocation_label:
    'Ingresa tu dirección para encontrar las mejores ofertas de las tiendas más cercanas',
  fullscreen: 'Pantalla completa',
  fullscreenExit: 'Minimizar pantalla',
  no_nearest_store_at: 'No hay tiendas cerca',
  nearest_store_at: 'La tienda más cercana {distance}',
  nearby_stores: 'Tiendas alrededor',
  show_all_pages: 'Ver todas las páginas',
  show: 'Mostrar',
  directionVertical: 'Scroll vertical',
  directionHorizontal: 'Scroll horizontal',
  share: 'Comparte',
  share_with_friends: 'Comparte con tus amigos',
  copy_link: 'Copia enlace',
  sms: 'SMS',
  email: 'email',
  more_stores: 'más tiendas',
  stores_within: 'Tiendas en un radio de {maxDistance}',
  invalid_offers_disclaimer:
    'Las ofertas de este catálogo no son válidas en las tiendas en tu alrededor, consulta otro catálogo o ubícate en otra zona.',
  download_pdf: 'Descarga PDF',
  available_options: 'Disponible en {numOptions} opciones:',
  flyer_unavailable_error:
    'No es posible abrir este catálogo. Verifica el enlace o vuelve a intentarlo más tarde.',
};
